import * as React from 'react';

const ConferenceSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.9 3.3c-.9-.9-2-1.3-3.2-1.3s-2.3.4-3.2 1.3l-.7-.7-.7.7.9.8c-.7 1.1-.9 2.5-.5 3.8L4.4 15l-.7.7.7.7 1.4 1.4.7.7 1.7-1.7V21h-3v1h7v-1h-3v-5.2l5.1-5.1c.5.2.9.2 1.4.2.8 0 1.7-.2 2.4-.7l.8.8.7-.7-.7-.7c1.8-1.7 1.8-4.5 0-6.3zM6.6 17.1l-1.4-1.4L12 8.9c.2.3.4.5.6.8.2.2.5.4.8.6l-6.8 6.8zm9.2-7.1c-.9 0-1.8-.4-2.5-1-1.1-1.1-1.3-2.8-.6-4.1l4.7 4.7c-.5.2-1.1.4-1.6.4zm-2.5-6c.7-.7 1.5-1 2.5-1s1.8.4 2.5 1c1.4 1.4 1.4 3.6 0 4.9l-5-4.9z"
        />
    </svg>
);

ConferenceSvg.displayName = 'ConferenceSvg';
export default ConferenceSvg;
